import { render } from "./TokenGetBalanceInput.vue?vue&type=template&id=5efcfacd&scoped=true"
import script from "./TokenGetBalanceInput.vue?vue&type=script&lang=js"
export * from "./TokenGetBalanceInput.vue?vue&type=script&lang=js"

import "./TokenGetBalanceInput.vue?vue&type=style&index=0&id=5efcfacd&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efcfacd"]])

export default __exports__